import Hls from "hls.js";

export const getStreamingDuration = async (url: string): Promise<number> => {
  const video = document.createElement("video");
  let duration;
  return new Promise((resolve, reject) => {
    if (!Hls.isSupported()) {
      video.src = url;
      video.addEventListener("durationchange", (event: any) => {
        if (event.target?.duration) {
          video.remove();
          duration = event.target.duration;
          resolve(event.target.duration * 1000);
        }
      });
    } else {
      const hls = new Hls({ startFragPrefetch: true });

      hls.on(Hls.Events.BUFFER_CREATED, function () {
        video.remove();
        duration = video.duration;
        resolve(video.duration * 1000);
      });

      hls.on(Hls.Events.ERROR, function (event, data) {
        let error = "Failed to load video";
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              // try to recover network error
              error = "Fatal network error encountered, try to recover";
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              error = "Fatal media error encountered, try to recover";
              hls.recoverMediaError();
              break;
            default:
              hls.destroy();
              break;
          }
        }
        reject(error);
      });

      hls.loadSource(url);
      // bind them together
      hls.attachMedia(video);
    }
  });
};
